module.exports = __webpack_public_path__ + "img/VivaLogo.bf00fce4.svg";